function Contact() {

    return <h1>Contato</h1>

}

export default Contact